import admin from './admin'
import info from './info'

export default {
    admin,
    info
}
